export const HEART_BEAT = 30000;
export const MAX_COOLDOWN = 10000;

export const KEEP_ALIVE_MSG = "Keep Alive";
